<div class="container-fluid pt-2" id="div-scroll">
  <div class="row shadow-sm bg-body rounded bg-transparent ">
    <div class="col shadow-sm bg-body rounded mr-2">
      <app-top-display-pannel (newItemEvent)="getStatusAllList($event)" #statuspannel></app-top-display-pannel>
      <div id="LoadingImage">
        <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
      </div>
    </div>
    <div class="col-5 shadow-sm bg-body rounded mr-2">
      <app-top-display-pannel (newItemEvent1)="getRCAAllList($event)" #RCApannel></app-top-display-pannel>
      <div id="LoadingImage">
        <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
      </div>
    </div>
    <div class="col  shadow-sm bg-body rounded mr-2">
      <app-top-display-pannel (newItemEvent2)="GetDueStatusAllList($event)" #dueStatusCount></app-top-display-pannel>
      <div id="LoadingImage">
        <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
      </div>
    </div>
  </div>
  <!--row 2 8/4-->
  <div class="row shadow-sm pt-3 mb-1 rounded " id="divOverall">
    <div class="col-sm-4 shadow-sm bg-body rounded ">
      <!-- Nav tabs -->
      <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-bs-toggle="tab" href="#list-view" role="tab" title="View Journal Status" (click)="GetViewList('List')">
            Status
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " data-bs-toggle="tab" href="#duestatus" role="tab" title="View Journal dues" (click)="GetViewList('List2')">
            Dues
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " data-bs-toggle="tab" href="#ApproveReject" role="tab" title="View Approve/Reject Status" (click)="GetViewList('List1')">
            Defects A/R
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#graph-view" role="tab" title="View Graph" (click)="GetViewList('Graph')">
            Chart View
          </a>
        </li>
        <li class="nav-item align-right">
          <div class="btn-group dropdown">
            <button type="button" class="btn btn-primary dropdown-toggle  btn-sm " data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa-solid fa-gear"></i>
            </button>
            <div class="dropdown-menu ">
              <button class="dropdown-item align-left" type="button" (click)="GetUserRoles()">UserRoles</button>
              <button class="dropdown-item align-left" type="button">Mail Template</button>
              <button class="dropdown-item align-left" type="button">Notification</button>
              <button class="dropdown-item align-left" type="button">Reports</button>
            </div>
          </div>
          <!-- The Modal -->
          <div class="modal" id="myModalUR" [style.display]="showModalUR ? 'block' : 'none'">
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
              <div class="modal-content" id="divDescription">
                <!-- Modal Header -->
                <div class="modal-header">
                  <h4 class="modal-title">User Roles For Defect Management</h4>
                  <button type="button" class="close" data-dismiss="modal" (click)="hideUserRoles()">&times;</button>
                </div>
                <!-- Modal body -->
                <div class="modal-body">
                  <p>Set User Roles</p>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)=" hideUserRoles()">Close</button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content">
        <div id="list-view" class="tab-pane active" role="tabpanel" style="overflow: hidden;">
          <div class="row">
            <div class="card-body " style="overflow: auto; height:55vh;">
              <app-master-grid (newItemEvent)="getJournalAllList($event)" #IRstatus></app-master-grid>

            </div>
            <div style="text-align:center" id="txtnodatastatus" hidden>No Data available in table</div>
          </div>
        </div>
        <div id="duestatus" class="tab-pane" role="tabpanel" style="overflow: hidden;">
          <div class="row">
            <div class="card-body " style="overflow: auto; height:55vh;">
              <app-master-grid (newItemEvent)="getJournalAllList($event)" #DueStatus></app-master-grid>
              <div id="txtnodataDue" style="text-align:center" hidden>No Data available in table</div>
            </div>
          </div>
        </div>
        <div id="ApproveReject" class="tab-pane" role="tabpanel" style="overflow: hidden;">
          <div class="row">
            <div class="card-body " style="overflow: auto; height:55vh;">
              <app-master-grid (newItemEvent)="getJournalAllList($event)" #ARstatus></app-master-grid>
              <div id="txtnodataAR" style="text-align:center" hidden>No Data available in table</div>
            </div>
          </div>
        </div>
        <div id="graph-view" class="tab-pane" role="tabpanel" style="overflow: hidden;">
          <div class="row  align-items-center justify-content-center">
            <div class="card-body " style="overflow: auto; height: 55vh;">
              <div id="divTabPanelView" style="text-align:center">
                <app-pie-chart #piechart></app-pie-chart>  <!--child component pie chart-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-8" id="div-size">
      <div class="card-body"  sstyle=" height: 70vh;">
        <div id="divDataList" class="table-responsive  p-3" style="width:100%">
          <button type="button" id="btnLoadList" (click)="getJournalAll()" style="display:none">Refresh</button>
          <button type="button" id="btnImportData" (click)="importExcelPopup()" style="display:none">Excel</button>
          <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
          <button #tooltipBtn type="button" id="btn_AddNew" class="btn btn-block btn-primary float-sm-right" (click)="createNewDefect()" style="display:none" data-toggle="tooltip" data-placement="top" title="Add New Journal">Add New</button>
          <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="ShowDataResponseparent()" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Click here to View report" style="display:none">POP-UP</button>
          <table #dataTable class="display" style="width:100%;" id="tbljournalissue"> </table>
          <div id="LoadingImage">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
          </div>
        </div>
        <!--defect response component-->
        <div id="divdefectResponse"><app-defect-response #defectResponse> </app-defect-response></div>
        <div id="divnewDefect"><app-defect-new #newDefect></app-defect-new></div>

        <div id="LoadingImagePopup">
          <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
        </div>
      </div>
      <!-- excel Popup -->
      <div class="modal" id="ExcelPopupBody" [style.display]="showExcelPopupBody ? 'block' : 'none'">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header" id="modal-headerid">
              <h4 class="modal-title">Import File Info</h4>
              <button type="button" class="close" data-dismiss="modal" (click)="hideExcelpopup()">&times;</button>
            </div>
            <button type="button" id="btnImportvalidation" (click)="addUpdateImportExcel()" style="display:none">Excel</button>
            <div class="modal-body">
              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <div id="SupportingFiles">
                      <label for="Txt_SupportingFiles">Choose File</label><br />
                      <input id="doc_file" type="file" class="form-control" (change)="onImportSelected($event)"><br />
                    </div>
                  </div>
                  <div class="col-2" style="margin-top:1.6em;" id="btnUpload">
                    <button type="submit" (click)="addUpdateExcel()" class="btn btn-outline-success waves-effect waves-light">
                      <i class="fa fa-upload"></i>&nbsp;{{hideExcelModalButton}}
                    </button>
                  </div>
                  <div class="col-4" id="dtn_downloadSupportingFiles" style="margin-top:1.6em;">
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light" id="DownloadCorrectFile" (click)="DownloadSupportFiles()"><i class="fa fa-download">&nbsp;</i><b>Download Sample File</b></button>
                  </div>
                </div>
                <label>Upload file should be same as download<span style="color: darkgreen;"> Excel</span> sample file with sheet name <span style="color: DodgerBlue;">DefectDetails</span></label>
              </div>
            </div>
            <div class="modal-body" style="display:none" id="tblErrorValidation">
              <div class="col-md-12">
                <div class="form-group tblRightsList fixTableHeadbudget">
                  <table id="tblErrorValidationList" class="table" style="overflow-y: scroll !important;">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Content</th>
                        <th>Status</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer" style="display:flex !important;">
              <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideExcelpopup()">Close</button>
            </div>
          </div>
        </div>
      </div>
      <!--Excel Validation Popup end -->
    </div>
  </div>
</div>



